import { trackEvent } from '@/analytics'
import { EVENT_CATEGORY, EVENT_NAME } from '@/constants/analytics'
import { EVENT_OTYPE } from '@/constants/awards'
import { GOAL_EVENT_TYPE } from '@/constants/goal'
import { INITIATIVE_EVENT_TYPE } from '@/constants/initiative'

/**
 * This function sends tracking events related to actions on Goal, KR, Initiative Events
 * @param event: Goal, KR, Initiative Event
 * @param eventAction: EVENT_ACTION
 * @param medium: the medium through which this action was triggered. Valid value is 'email' if applicable
 */
export default (event, eventAction, medium = null) => {
  let eventName
  if (event.otype === EVENT_OTYPE.GOAL_EVENT) {
    switch (event.type) {
      case GOAL_EVENT_TYPE.CHECKIN:
        eventName = EVENT_NAME.CHECKIN
        break
      case GOAL_EVENT_TYPE.CREATED:
        eventName = EVENT_NAME.CREATE_GOAL
        break
      case GOAL_EVENT_TYPE.AWARD:
        eventName = event.keyResultId ? EVENT_NAME.KR_AWARD : EVENT_NAME.GOAL_AWARD
        break
      case GOAL_EVENT_TYPE.COMMENT:
        eventName = event.keyResultId ? EVENT_NAME.KR_COMMENT : EVENT_NAME.GOAL_COMMENT
        break
      case GOAL_EVENT_TYPE.CLOSED:
        eventName = event.keyResultId ? EVENT_NAME.KR_CLOSED : EVENT_NAME.GOAL_CLOSED
        break
      case GOAL_EVENT_TYPE.REOPENED:
        eventName = event.keyResultId ? EVENT_NAME.KR_REOPENED : EVENT_NAME.GOAL_REOPENED
        break
    }
  } else if (event.otype === EVENT_OTYPE.INITIATIVE_EVENT) {
    switch (event.type) {
      case INITIATIVE_EVENT_TYPE.COMMENT:
        eventName = EVENT_NAME.INITIATIVE_COMMENT
        break
      case INITIATIVE_EVENT_TYPE.CREATED:
        eventName = EVENT_NAME.CREATE_INITIATIVE
        break
      case INITIATIVE_EVENT_TYPE.CLOSED:
        eventName = EVENT_NAME.INITIATIVE_CLOSED
        break
      case INITIATIVE_EVENT_TYPE.REOPENED:
        eventName = EVENT_NAME.INITIATIVE_REOPENED
        break
      case INITIATIVE_EVENT_TYPE.FIELD_CHANGED:
        eventName = EVENT_NAME.INITIATIVE_FIELD_CHANGED
        break
      case INITIATIVE_EVENT_TYPE.AWARD:
        eventName = EVENT_NAME.INITIATIVE_AWARD
        break
    }
  }
  if (eventName) {
    trackEvent(EVENT_CATEGORY.ACTIVITY, eventAction, eventName, null, medium)
  }
}
